import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: james-fry
 * id 131D3C5D-880D-486B-A041-039B1F1E5284
 * name floor-plan
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/floor-plan.svg
 * tags
 * - Home Automation 
 */
export const FloorPlanIcon = createSvgIcon(<><path d="M10,5V10H9V5H5V13H9V12H10V17H9V14H5V19H12V17H13V19H19V17H21V21H3V3H21V15H19V10H13V15H12V9H19V5H10Z" /></>, 'FloorPlanIcon');
export default FloorPlanIcon